import { useLayoutEffect, useRef, useState } from 'react';
import { MultiGrid } from 'react-virtualized';
import { CELL_SETTINGS } from './constants';

const LAST_COLUMN_SELECTOR = `[${CELL_SETTINGS.lastColumnDataAttribute}="true"]`;

export function useMultiGrid() {
  const multiGridRef = useRef<MultiGrid | null>(null);
  const scrollLeftValRef = useRef(0);
  const scrollTopValRef = useRef(0);

  function handleHorizontalScroll(isScrolled: boolean) {
    if (isScrolled) {
      const selector = `${LAST_COLUMN_SELECTOR}:not(.${CELL_SETTINGS.hasBorderClassName})`;
      document.querySelectorAll(selector).forEach(eachNode => {
        eachNode.classList.add(CELL_SETTINGS.hasBorderClassName);
      });
    } else {
      const selector = `${LAST_COLUMN_SELECTOR}.${CELL_SETTINGS.hasBorderClassName}`;
      document.querySelectorAll(selector).forEach(eachNode => {
        eachNode.classList.remove(CELL_SETTINGS.hasBorderClassName);
      });
    }
  }

  function onScroll(scrollLeft: number, scrollTop: number) {
    if (scrollLeftValRef.current !== scrollLeft) {
      handleHorizontalScroll(scrollLeft > 0);
    }

    scrollLeftValRef.current = scrollLeft;
    scrollTopValRef.current = scrollTop;
  }

  return {
    multiGridRef,
    onScroll,
  };
}

export function useTableHeight(
  listLength: number,
  selectedFilterKeysLength: number,
  forceRowHeight: boolean,
) {
  const listRef = useRef<HTMLDivElement | null>(null);
  const [tableHeight, setTableHeight] = useState(0);
  const availableHeight = listRef.current?.clientHeight ?? 0;

  useLayoutEffect(() => {
    function calculcateTableHeight() {
      const totalRowHeight = CELL_SETTINGS.headerHeight + CELL_SETTINGS.cellDataHeight * listLength;

      if (forceRowHeight || availableHeight === 0) {
        return totalRowHeight;
      }
      return Math.min(availableHeight, totalRowHeight);
    }

    setTableHeight(calculcateTableHeight());
  }, [listLength, selectedFilterKeysLength, forceRowHeight, availableHeight]);

  return {
    listRef,
    tableHeight,
  };
}
